export const youtubeLessons  = {

  "1-1-1-what-is-the-web-and-how-it-works": "hu-q2zYwEYs",
  "1-1-2-introduction-to-html-structure": "mbeT8mpmtHA",
  "2-1-2-forms-inputs-and-validation-basics": "YwbIeMlxZAU",
  "1-3-1-how-css-works": "D3iEE29ZXRM",
  "1-3-2-selectors-properties-and-values": "FHZn6706e3Q",
  "2-1-1-semantic-html-and-accessibility": "kGW8Al_cga4",
  "1-4-2-applying-css-to-create-a-layout": "25R1Jl5P7Mw", 
  "2-3-1-media-queries-and-breakpoints": "XQaHAAXIVg8", 
  "2-3-2-fluid-layouts-and-units": "FMu2cKWD90g",
  "1-4-3-publishing-your-first-webpage": "Xig7NsIE6DI",

};
